import React from 'react';
import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { IContentProps } from '../types';
import { validationSchema, FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './utils/formConfig';
import useContent from './useContent';

const Content: React.FC<IContentProps> = (props) => {
	const { handleSubmit, handleCancel, showLoader, setShowLoader } = useContent(props);

	return (
		<FormBuilder
			data={EMPTY_OBJECT}
			mode='create'
			handleFormSubmit={handleSubmit}
			handleFormCancel={handleCancel}
			validationSchema={validationSchema}
			showLoader={showLoader}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			buttonLabels={{
				submitLabel: 'Submit',
				discardLabel: 'Cancel'
			}}
			hidePopUp
		/>
	);
};

export default Content;
